module.exports = __webpack_public_path__ + "static/img/index_right_top_book_img.ca35909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_right_top_book_img.jpg
// module id = LW2j
// module chunks = 0